import React from "react";
import { Link as RouterLink } from "react-router-dom";
import PropTypes from "prop-types";

class SiderBarSubItem extends React.Component {
  render() {
    const { item, click } = this.props;
    const badgeClass = item.badge ? "nav-item-badge" : "";
    return (
      <div
        className={`sub-nav-item ${item.active && "nav-active"}`}
        onClick={click}
      >
        <RouterLink
          className={`flex-row-vertical-center match-parent sub-nav-item-main justify-content-between ${badgeClass}`}
          to={item.path}
        >
          <div>
            {item.imageSrc ? (
              <img className="nav-item-icon" src={item.imageSrc} alt="" />
            ) : null}
            <span>{item.name}</span>
          </div>
          <span className="nav-badge-dot" />
        </RouterLink>
      </div>
    );
  }
}

SiderBarSubItem.propTypes = {
  item: PropTypes.shape({
    active: PropTypes.bool,
    path: PropTypes.string.isRequired,
    imageSrc: PropTypes.any.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  click: PropTypes.func,
};

SiderBarSubItem.defaultProps = {
  click: undefined,
};

export default SiderBarSubItem;
